// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2Mdi2";
var _3 = "notification-37yEE";
var _4 = "notification__html-2bCs4";
var _5 = "notification__content-2IAkF";
var _6 = "notifications-269EE";
export { _1 as "__esModule", _2 as "container", _3 as "notification", _4 as "notification__html", _5 as "notification__content", _6 as "notifications" }
export default { "__esModule": _1, "container": _2, "notification": _3, "notification__html": _4, "notification__content": _5, "notifications": _6 }
